export default "__VITE_ASSET__04fc9490__"